import PropTypes from 'prop-types';
import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { Route, Switch } from 'react-router-dom';
import ConnectedLoggedInChecker from '../../Login/LoggedInChecker/LoggedInChecker';
import { NotFound } from '../../NotFound/NotFound';
import { ProjectManagerHeader } from '../Header/ProjectManagerHeader';
import './ProjectMangerApp.css';
import ConnectedWorkOrder from '../../WorkOrder/WorkOrder';
import ConnectedProjectManagerHome, {
  ConnectedProjectManagerApprovedHome,
  ConnectedProjectManagerSubmittedHome,
} from '../Home/ProjectManagerHome';
import ConnectedProjectManagerProjects from '../Projects/ProjectManagerProjects';
import ConnectedWorkOrderApprove from '../WorkOrderApprove/WorkOrderApprove';
import ConnectedProjectManagerHistory from '../History/ProjectManagerHistory';
import ConnectedEmployeeStats from '../../EmployeeStats/EmployeeStats';
import { Footer } from '../../Footer/Footer';

export const ProjectManagerApp = ({ location }) => (
  <span>
    <ConnectedLoggedInChecker />
    <ProjectManagerHeader location={location.pathname} />
    <Grid className="authenticatedAppGrid" fluid >
      <Row>
        <Col xsOffset={1} xs={10} >
          <Switch>
            <Route exact path="/pm/workorders/:id" component={ConnectedWorkOrder} />
            <Route exact path="/pm/workorders/:id/approve" component={ConnectedWorkOrderApprove} />
            <Route exact path="/pm/projects" component={ConnectedProjectManagerProjects} />
            <Route exact path="/pm" component={ConnectedProjectManagerHome} />
            <Route exact path="/pm/dwrs/approved" component={ConnectedProjectManagerApprovedHome} />
            <Route exact path="/pm/dwrs/submitted" component={ConnectedProjectManagerSubmittedHome} />
            <Route exact path="/pm/history" component={ConnectedProjectManagerHistory} />
            <Route exact path="/pm/stats" component={ConnectedEmployeeStats} />
            <Route component={NotFound} />
          </Switch>
        </Col>
      </Row>
      <Row>
        <Footer />
      </Row>
    </Grid>
  </span>);

ProjectManagerApp.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }),
};

ProjectManagerApp.defaultProps = {
  location: { pathname: '/' },
};



// WEBPACK FOOTER //
// ./src/components/ProjectManager/ProjectManagerApp/ProjectManagerApp.jsx